export enum PropertyType {
  Commercial = 'Commercial',
  Industry = 'Industry',
  Residential = 'Residential',
  IT_ITesBuilding = 'IT/ITeS Building',
}
